import * as angular from 'angular';
import { IEmbedService } from '../services';

angular.module('app').controller('NotFoundController', notFound);

function notFound($scope: angular.IScope, embedService: IEmbedService) {
	$scope.isEmbedded = embedService.isEmbedded;
}
